/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  backgroundColor: "white",
  padding: "2rem",
  textAlign: "center",
  fontFamily: "Lexend Deca" // inherit default
};

const questionStyle = {
  fontSize: "2rem",
  fontWeight: "bold",
  marginBottom: "2rem",
  color: "black"
};

const answerStyle = {
  fontSize: "1.5rem",
  fontWeight: "500",
  marginTop: "1rem",
  color: "#10b981"
};

const buttonContainerStyle = {
  position: "fixed",
  bottom: "2rem",
  display: "flex",
  gap: "1rem"
};

const buttonStyle = {
  padding: "0.75rem 1.5rem",
  fontSize: "1.1rem",
  backgroundColor: "#1f2937",
  color: "white",
  borderRadius: "0.5rem",
  border: "none",
  cursor: "pointer",
  transition: "background-color 0.3s",
  fontFamily: "inherit" // fix font mismatch
};

function decodeHTML(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export default function TriviaPartyGame() {
  const [questionData, setQuestionData] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  const fetchQuestion = async () => {
    setShowAnswer(false);
    setError(null);
    setQuestionData(null);

    try {
      const res = await fetch("https://opentdb.com/api.php?amount=1&type=multiple");
      if (!res.ok) throw new Error("Network error");

      const data = await res.json();
      const q = data?.results?.[0];

      if (!q) throw new Error("No trivia question found");

      setQuestionData({
        question: decodeHTML(q.question),
        answer: decodeHTML(q.correct_answer)
      });
      setRetryCount(0); // reset on success
    } catch (err) {
      // Try up to 3 times
      if (retryCount < 3) {
        setTimeout(() => {
          setRetryCount(retryCount + 1);
          fetchQuestion();
        }, 1000);
      } else {
        setError("Failed to fetch trivia. Try again in a moment.");
      }
    }
  };

  useEffect(() => {
    fetchQuestion();
  }, []);

  return (
    <div style={containerStyle}>
      {error && <div style={{ color: "red" }}>{error}</div>}
      {!error && !questionData && <div>Loading, please wait...</div>}

      {questionData && (
        <>
          <div style={questionStyle}>{questionData.question}</div>
          {showAnswer && <div style={answerStyle}>Answer: {questionData.answer}</div>}
        </>
      )}

      <div style={buttonContainerStyle}>
        <button
          style={buttonStyle}
          onClick={() => setShowAnswer(true)}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#374151")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#1f2937")}
        >
          Reveal Answer
        </button>

        <button
          style={buttonStyle}
          onClick={fetchQuestion}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#374151")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#1f2937")}
        >
          Next Question
        </button>
      </div>
    </div>
  );
}
